import { atom } from 'jotai';

export const currentlyOpenLMDialogsAtom = atom(new Map());
